// src/index.tsx
import React from "react";
import { z } from "zod";
var FONT_FAMILY_SCHEMA = z
  .enum([
    "MODERN_SANS",
    "BOOK_SANS",
    "ORGANIC_SANS",
    "GEOMETRIC_SANS",
    "HEAVY_SANS",
    "ROUNDED_SANS",
    "MODERN_SERIF",
    "BOOK_SERIF",
    "MONOSPACE",
    "ARIAL",
    "ARIAL_BLACK",
    "ARIAL_NARROW",
    "ARIAL_ROUNDED_MT_BOLD",
    "AVANT_GARDE",
    "CALIBRI",
    "CANDARA",
    "CENTURY_GOTHIC",
    "FRANKLIN_GOTHIC_MEDIUM",
    "FUTURA",
    "GENEVA",
    "GILL_SANS",
    "HELVETICA",
    "IMPACT",
    "LUCIDA_GRANDE",
    "OPTIMA",
    "SEGOE_UI",
    "TAHOMA",
    "TREBUCHET_MS",
    "VERDANA",
    "BIG_CASLON",
    "BODONI_MT",
    "BOOK_ANTIQUA",
    "CALISTO_MT",
    "CAMBRIA",
    "DIDOT",
    "GARAMOND",
    "GEORGIA",
    "GOUDY_OLD_STYLE",
    "HOEFLER_TEXT",
    "LUCIDA_BRIGHT",
    "PALATINO",
    "PERPETUA",
    "ROCKWELL",
    "ROCKWELL_EXTRA_BOLD",
    "BASKERVILLE",
    "TIMES_NEW_ROMAN",
    "CONSOLAS",
    "COURIER_NEW",
    "LUCIDA_CONSOLE",
    "LUCIDA_SANS_TYPEWRITER",
    "MONACO",
    "ANDALE_MONO",
    "COPPERPLATE",
    "PAPYRUS",
    "BRUSH_SCRIPT_MT",
  ])
  .nullable()
  .optional();
function getFontFamily(fontFamily) {
  switch (fontFamily) {
    case "MODERN_SANS":
      return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
    case "BOOK_SANS":
      return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
    case "ORGANIC_SANS":
      return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
    case "GEOMETRIC_SANS":
      return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
    case "HEAVY_SANS":
      return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
    case "ROUNDED_SANS":
      return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
    case "MODERN_SERIF":
      return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
    case "BOOK_SERIF":
      return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
    case "MONOSPACE":
      return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
    case "ARIAL":
      return 'Arial, "Helvetica Neue", Helvetica, sans-serif';
    case "ARIAL_BLACK":
      return '"Arial Black", Gadget, sans-serif';
    case "ARIAL_NARROW":
      return '"Arial Narrow", sans-serif';
    case "ARIAL_ROUNDED_MT_BOLD":
      return '"Arial Rounded MT Bold", sans-serif';
    case "AVANT_GARDE":
      return '"Avant Garde", Avantgarde, "Century Gothic", sans-serif';
    case "CALIBRI":
      return 'Calibri, "Trebuchet MS", sans-serif';
    case "CANDARA":
      return 'Candara, "Trebuchet MS", sans-serif';
    case "CENTURY_GOTHIC":
      return '"Century Gothic", CenturyGothic, AppleGothic, sans-serif';
    case "FRANKLIN_GOTHIC_MEDIUM":
      return '"Franklin Gothic Medium", "Franklin Gothic", "ITC Franklin Gothic", sans-serif';
    case "FUTURA":
      return 'Futura, "Trebuchet MS", Arial, sans-serif';
    case "GENEVA":
      return "Geneva, Tahoma, Verdana, sans-serif";
    case "GILL_SANS":
      return '"Gill Sans", "Gill Sans MT", Calibri, sans-serif';
    case "HELVETICA":
      return "Helvetica, Arial, sans-serif";
    case "IMPACT":
      return 'Impact, Haettenschweiler, "Franklin Gothic Bold", Charcoal, "Helvetica Inserat", "Bitstream Vera Sans Bold", sans-serif';
    case "LUCIDA_GRANDE":
      return '"Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva, Verdana, sans-serif';
    case "OPTIMA":
      return 'Optima, Segoe, "Segoe UI", Candara, Calibri, Arial, sans-serif';
    case "SEGOE_UI":
      return '"Segoe UI", Frutiger, "Frutiger Linotype", "Dejavu Sans", "Helvetica Neue", Arial, sans-serif';
    case "TAHOMA":
      return "Tahoma, Verdana, Segoe, sans-serif";
    case "TREBUCHET_MS":
      return '"Trebuchet MS", "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", sans-serif';
    case "VERDANA":
      return "Verdana, Geneva, sans-serif";
    case "BIG_CASLON":
      return '"Big Caslon", "Book Antiqua", "Palatino Linotype", Georgia, serif';
    case "BODONI_MT":
      return '"Bodoni MT", Didot, "Didot LT STD", "Hoefler Text", Garamond, "Times New Roman", serif';
    case "BOOK_ANTIQUA":
      return '"Book Antiqua", Palatino, "Palatino Linotype", "Palatino LT STD", Georgia, serif';
    case "CALISTO_MT":
      return '"Calisto MT", "Bookman Old Style", Bookman, "Goudy Old Style", Garamond, "Hoefler Text", "Bitstream Charter", Georgia, serif';
    case "CAMBRIA":
      return "Cambria, Georgia, serif";
    case "DIDOT":
      return 'Didot, "Didot LT STD", "Hoefler Text", Garamond, "Times New Roman", serif';
    case "GARAMOND":
      return 'Garamond, Baskerville, "Baskerville Old Face", "Hoefler Text", "Times New Roman", serif';
    case "GEORGIA":
      return 'Georgia, Times, "Times New Roman", serif';
    case "GOUDY_OLD_STYLE":
      return '"Goudy Old Style", Garamond, "Big Caslon", "Times New Roman", serif';
    case "HOEFLER_TEXT":
      return '"Hoefler Text", "Baskerville Old Face", Garamond, "Times New Roman", serif';
    case "LUCIDA_BRIGHT":
      return '"Lucida Bright", Georgia, serif';
    case "PALATINO":
      return 'Palatino, "Palatino Linotype", "Palatino LT STD", "Book Antiqua", Georgia, serif';
    case "PERPETUA":
      return 'Perpetua, Baskerville, "Big Caslon", "Palatino Linotype", Palatino, serif';
    case "ROCKWELL":
      return 'Rockwell, "Courier Bold", Courier, Georgia, Times, "Times New Roman", serif';
    case "ROCKWELL_EXTRA_BOLD":
      return '"Rockwell Extra Bold", "Rockwell Bold", monospace';
    case "BASKERVILLE":
      return 'Baskerville, "Baskerville Old Face", "Hoefler Text", Garamond, "Times New Roman", serif';
    case "TIMES_NEW_ROMAN":
      return '"Times New Roman", Times, serif';
    case "CONSOLAS":
      return "Consolas, monaco, monospace";
    case "COURIER_NEW":
      return '"Courier New", Courier, monospace';
    case "LUCIDA_CONSOLE":
      return '"Lucida Console", "Lucida Sans Typewriter", monaco, "Bitstream Vera Sans Mono", monospace';
    case "LUCIDA_SANS_TYPEWRITER":
      return '"Lucida Sans Typewriter", "Lucida Console", monaco, "Bitstream Vera Sans Mono", monospace';
    case "MONACO":
      return 'monaco, Consolas, "Lucida Console", monospace';
    case "ANDALE_MONO":
      return '"Andale Mono", AndaleMono, monospace';
    case "COPPERPLATE":
      return 'Copperplate, "Copperplate Gothic Light", fantasy';
    case "PAPYRUS":
      return "Papyrus, fantasy";
    case "BRUSH_SCRIPT_MT":
      return '"Brush Script MT", cursive';
  }
  return void 0;
}
var COLOR_SCHEMA = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/)
  .nullable()
  .optional();
var PADDING_SCHEMA = z
  .object({
    top: z.number(),
    bottom: z.number(),
    right: z.number(),
    left: z.number(),
  })
  .optional()
  .nullable();
var getPadding = (padding) =>
  padding
    ? `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`
    : void 0;
var ButtonPropsSchema = z.object({
  style: z
    .object({
      backgroundColor: COLOR_SCHEMA,
      fontSize: z.number().min(0).optional().nullable(),
      fontFamily: FONT_FAMILY_SCHEMA,
      fontWeight: z.enum(["bold", "normal"]).optional().nullable(),
      textAlign: z.enum(["left", "center", "right"]).optional().nullable(),
      padding: PADDING_SCHEMA,
    })
    .optional()
    .nullable(),
  props: z
    .object({
      buttonBackgroundColor: COLOR_SCHEMA,
      buttonStyle: z
        .enum(["rectangle", "pill", "rounded"])
        .optional()
        .nullable(),
      buttonTextColor: COLOR_SCHEMA,
      fullWidth: z.boolean().optional().nullable(),
      size: z
        .enum(["x-small", "small", "large", "medium"])
        .optional()
        .nullable(),
      text: z.string().optional().nullable(),
      url: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
});
function getRoundedCorners(props) {
  var _a;
  const buttonStyle =
    (_a = props == null ? void 0 : props.buttonStyle) != null
      ? _a
      : ButtonPropsDefaults.buttonStyle;
  switch (buttonStyle) {
    case "rectangle":
      return void 0;
    case "pill":
      return 64;
    case "rounded":
    default:
      return 4;
  }
}
function getButtonSizePadding(props) {
  var _a;
  const size =
    (_a = props == null ? void 0 : props.size) != null
      ? _a
      : ButtonPropsDefaults.size;
  switch (size) {
    case "x-small":
      return [4, 8];
    case "small":
      return [8, 12];
    case "large":
      return [16, 32];
    case "medium":
    default:
      return [12, 20];
  }
}
var ButtonPropsDefaults = {
  text: "",
  url: "",
  fullWidth: false,
  size: "medium",
  buttonStyle: "rounded",
  buttonTextColor: "#FFFFFF",
  buttonBackgroundColor: "#999999",
};
function Button({ style, props }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const text =
    (_a = props == null ? void 0 : props.text) != null
      ? _a
      : ButtonPropsDefaults.text;
  const url =
    (_b = props == null ? void 0 : props.url) != null
      ? _b
      : ButtonPropsDefaults.url;
  const fullWidth =
    (_c = props == null ? void 0 : props.fullWidth) != null
      ? _c
      : ButtonPropsDefaults.fullWidth;
  const buttonTextColor =
    (_d = props == null ? void 0 : props.buttonTextColor) != null
      ? _d
      : ButtonPropsDefaults.buttonTextColor;
  const buttonBackgroundColor =
    (_e = props == null ? void 0 : props.buttonBackgroundColor) != null
      ? _e
      : ButtonPropsDefaults.buttonBackgroundColor;
  const padding = getButtonSizePadding(props);
  const textRaise = (padding[1] * 2 * 3) / 4;
  const wrapperStyle = {
    backgroundColor:
      (_f = style == null ? void 0 : style.backgroundColor) != null
        ? _f
        : void 0,
    textAlign:
      (_g = style == null ? void 0 : style.textAlign) != null ? _g : void 0,
    padding: getPadding(style == null ? void 0 : style.padding),
  };
  const linkStyle = {
    color: buttonTextColor,
    fontSize: (_h = style == null ? void 0 : style.fontSize) != null ? _h : 16,
    fontFamily: getFontFamily(style == null ? void 0 : style.fontFamily),
    fontWeight:
      (_i = style == null ? void 0 : style.fontWeight) != null ? _i : "bold",
    backgroundColor: buttonBackgroundColor,
    borderRadius: getRoundedCorners(props),
    display: fullWidth ? "block" : "inline-block",
    padding: `${padding[0]}px ${padding[1]}px`,
    textDecoration: "none",
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    { style: wrapperStyle },
    /* @__PURE__ */ React.createElement(
      "a",
      { href: url, style: linkStyle, target: "_blank" },
      /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: `<!--[if mso]><i style="letter-spacing: ${padding[1]}px;mso-font-width:-100%;mso-text-raise:${textRaise}" hidden>&nbsp;</i><![endif]-->`,
        },
      }),
      /* @__PURE__ */ React.createElement("span", null, text),
      /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: `<!--[if mso]><i style="letter-spacing: ${padding[1]}px;mso-font-width:-100%" hidden>&nbsp;</i><![endif]-->`,
        },
      })
    )
  );
}
export { Button, ButtonPropsDefaults, ButtonPropsSchema };
